const locale = document.documentElement.getAttribute('locale') ?
    adjustLocale(document.documentElement.getAttribute('locale')) : 'nl';

function adjustLocale(locale) {
    const [lang, region] = locale.split('_');
    return region ? `${lang}_${region.toUpperCase()}` : lang;
}

window.Translator.locale = locale;

const trans = (key, parameters = {}, fallback = key) => {
    if (!window.Translator) return fallback;
    const translation = window.Translator.trans(key, parameters, null, locale);
    return translation === key ? fallback : translation;
};

export const transChoice = (key, number = 1, parameters = {}, fallback = key) => {
    if (!window.Translator) return fallback;
    const translation = window.Translator.transChoice(key, number, parameters);
    return translation === key ? fallback : translation;
};

export default trans;
